const urlPath   = window.location.pathname
const tokenName = 'secureToken'

export function getTokenName() {
  return tokenName
}

export function getToken() {
  return window.localStorage.getItem(getTokenName()) || ''
}

export function isValidPath() {
  return urlPath.indexOf('/api') !== 0
}

export function initAuthForAxios() {
  if (!isValidPath()) return

  const token = getToken()

  // Supply API with OAuth token if exists
  if (token) {
    window.axios.defaults.headers.common.Authorization = `Bearer ${token}`
  }
}

export function handleUnauthorized(error) {
  if (error.response && error.response.status === 401) {
    window.location.href = '/login'
  }

  return Promise.reject(error)
}
